import React from 'react'
import classnames from 'classnames'

import { GovMessageWhen } from './when'
import { GovMessageDisplay } from './message'
import { GovCorrespondenceDisplay } from './correspondence'
import DeleteGovMessage from './delete-message'
import { messageSubject, messageType, isCriticalNoticeType } from '../helpers'
import './gov-messages.css'

const GovMessageWrapper = ({ subject, type = 'INFO', dateTime, children }) => (
  <div className="govMessage--display">
    {isCriticalNoticeType(type) ? <h4 className="govMessage--type">{messageType(type)}</h4> : null}

    <ul>
      <li className="govMessage--time">
        <GovMessageWhen dateTime={dateTime} />
      </li>
      <li className="govMessage--subject">{messageSubject(subject)}</li>
    </ul>

    <div className="govMessage--body">{children}</div>
  </div>
)

export const GovMessage = ({ message, afterDelete, apiEndPoint }) => (
  <li
    className={classnames({
      'govMessages--listItem': true,
      [`govMessage--display__${(message.gov_record.type || 'info').toLowerCase()}`]: true,
    })}>
    <GovMessageWrapper {...message.gov_record}>
      {React.createElement(message.link ? GovCorrespondenceDisplay : GovMessageDisplay, {
        ...message.gov_record,
        link: message.link,
      })}
    </GovMessageWrapper>
    <DeleteGovMessage key={apiEndPoint} afterDelete={afterDelete} apiEndPoint={apiEndPoint} />
  </li>
)



// WEBPACK FOOTER //
// ./src/ui/gov-messages/views/index.jsx